import Image from 'next/future/image';
import { BannerData } from '.';
import buybackBanner from '@/public/images/buyback/bannerBuyback.gif';

export default function Banner({ heading, description }: BannerData) {
  return (
    <>
      <div className="relative pb-[45vw] xs:pb-[40vw] sm:pb-[33vw] lg:pb-0">
        <div className="absolute h-full w-full lg:hidden">
          <Image
            alt="buyback banner"
            src={buybackBanner}
            className="h-full w-full object-cover"
            priority={true}
          />
        </div>
        <div className="hidden lg:block">
          <Image
            src={buybackBanner}
            alt="buyback banner"
            priority={true}
            className="h-full w-full object-fill"
          />
        </div>
        <div className="absolute top-1/2 left-0 w-full -translate-y-1/2">
          <div className="reebelo-container flex flex-col py-8 sm:py-12 md:flex-row md:py-12 lg:py-16">
            <div className="w-full lg:w-[85%]">
              <h1 className="hidden">{heading}</h1>
              <h2 className="mb-0 text-center text-lg font-extrabold text-white drop-shadow-lg xxs:text-xl xs:text-2xl sm:text-left md:text-3xl 2xl:text-4xl">
                {heading}
              </h2>
              <p className="mt-0 mb-0 text-center text-base !leading-tight text-white drop-shadow-lg xxs:mt-1 sm:text-left sm:text-lg lg:text-xl 2xl:text-2xl">
                {description && description !== ''
                  ? description
                  : `Convenient & Trustworthy`}
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
